import React, { useEffect, useState } from "react";
import { Badge, Card, Col, Container, Row, Table, Button, Breadcrumb, BreadcrumbItem } from "react-bootstrap";
import { FaDownload } from "react-icons/fa";
import { format } from "date-fns";
import { GetAllNotifications } from "../../utils/queries";

const NotificationList = () => {
  const [notiList, setNotiList] = useState([]);

  const fetchData = async () => {
    try {
      const response = await GetAllNotifications();
      console.log(response, "response");
      setNotiList(response[0]?.InfoField2);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getStatusBadge = (status) => {
    return status === "unread" ? (
      <Badge bg="warning" text="dark">
        Unread
      </Badge>
    ) : (
      <Badge bg="success">Read</Badge>
    );
  };

  return (
    <>
      <Breadcrumb>
        <BreadcrumbItem>
          <a href="/dashboard" className="text-success text-decoration-none">
            Dashboard
          </a>
        </BreadcrumbItem>
        <BreadcrumbItem active>Notification List</BreadcrumbItem>
      </Breadcrumb>
      <Container className="py-4">
        <h4 className="text-center mb-4">Notification List</h4>

        {/* Table view for desktop */}
        <div className="d-none d-md-block">
          <Table bordered striped hover responsive>
            <thead>
              <tr>
                <th>Title</th>
                <th>Scope</th>
                <th>Created At</th>
                <th>Status</th>
                <th>Attachment</th>
              </tr>
            </thead>
            <tbody>
              {notiList.length > 0 ? (
                notiList.map((item) => (
                  <tr key={item.notification_id}>
                    <td>{item.title}</td>
                    <td>{item.recipient_scope}</td>
                    <td>{format(new Date(item.created_at), "dd MMM yyyy, hh:mm a")}</td>
                    <td>{getStatusBadge(item.status)}</td>
                    <td>
                      {item.file_path ? (
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          href={`${process.env.REACT_APP_API_URL}${item.file_path}`}
                          target="_blank"
                        >
                          <FaDownload className="me-1" /> Download
                        </Button>
                      ) : (
                        "—"
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="text-center">
                    No Notifications Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        {/* Card view for mobile */}
        <div className="d-md-none">
          <Row xs={1} className="g-4">
            {notiList.length > 0 ? (
              notiList.map((item) => (
                <Col key={item.notification_id}>
                  <Card className="shadow border-0 h-100">
                    <Card.Body>
                      <Card.Title>{item.title}</Card.Title>
                      <Card.Subtitle className="mb-2 text-muted">{item.recipient_scope}</Card.Subtitle>

                      <div className="mb-2">
                        <strong>Created:</strong> {format(new Date(item.created_at), "dd MMM yyyy, hh:mm a")}
                      </div>

                      <div className="mb-3">
                        <strong>Status:</strong> {getStatusBadge(item.status)}
                      </div>

                      {item.file_path && (
                        <Button
                          variant="outline-primary"
                          size="sm"
                          href={`${process.env.REACT_APP_API_URL}${item.file_path}`}
                          target="_blank"
                        >
                          <FaDownload className="me-1" />
                          View File
                        </Button>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              ))
            ) : (
              <p>No Notifications Found</p>
            )}
          </Row>
        </div>
      </Container>
    </>
  );
};

export default NotificationList;
